import React from 'react';
import { UitkText } from 'uitk-react-text';

interface ProductPlaceHolderProps {
  label: string;
}
const ProductPlaceHolder: React.FC<ProductPlaceHolderProps> = ({ label }) => {
  return (
    <div className="product-placeholder">
      <UitkText align="center" weight="medium">
        {label}
      </UitkText>
    </div>
  );
};

export default ProductPlaceHolder;
